import { Building2, Home, KeyRound, Phone, User } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "./content";

const WHO = [
  { icon: Building2, title: "Företag & kontor", text: "Hjälp att hålla kontoret rent och trivsamt, både löpande och när behovet uppstår." },
  { icon: Home, title: "BRF:er", text: "Städning av trapphus, entréer och gemensamma utrymmen som används varje dag." },
  { icon: KeyRound, title: "Fastighetsägare & förvaltare", text: "Städning vid renovering, mellan hyresgäster eller som återkommande hjälp i fastigheten." },
];

export const Audience = () => (
  <section id="foretag" className="bg-white pt-12 pb-14 md:pt-14 md:pb-20" data-testid="audience-section">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:items-start lg:gap-14">
      <div className="lg:col-span-7">
        <p className="eyebrow">Personlig städservice</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">För företag, BRF:er och fastighetsägare</h2>
        <ul className="mt-8 space-y-5">
          {WHO.map(({ icon: Icon, title, text }) => (
            <li key={title} className="flex gap-4">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[var(--sand)]">
                <Icon size={20} aria-hidden />
              </span>
              <div>
                <h3 className="text-lg font-bold">{title}</h3>
                <p className="mt-1 leading-relaxed text-[var(--ink-soft)]">{text}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="mt-6 flex items-center gap-2 text-sm text-[var(--ink-soft)]">
          <User size={16} aria-hidden /> Vi hjälper även privatpersoner med bland annat flyttstädning och fönsterputs.
        </p>
      </div>
      <aside className="rounded-3xl bg-[var(--paper)] p-6 sm:p-8 lg:col-span-5" data-testid="process-steps">
        <p className="eyebrow">Snabb kontakt</p>
        <h3 className="mt-3 text-2xl font-bold sm:text-3xl">Enkelt att komma igång</h3>
        <p className="mt-4 leading-relaxed text-[var(--ink-soft)]">
          Berätta kort vad ni behöver hjälp med, så går Mats igenom uppdraget med er och tar fram ett förslag som passar. Vill ni hellre prata direkt? Ring honom gärna.
        </p>
        <div className="mt-6 grid gap-3">
          <a href="#offert" className="btn btn-red w-full" data-testid="process-quote-button">Begär offert</a>
          <a href={PHONE_HREF} className="btn btn-outline w-full">
            <Phone size={18} aria-hidden /> {PHONE_DISPLAY}
          </a>
        </div>
      </aside>
    </div>
  </section>
);
